import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_results} from "../_signals/s_results";
import {IResult} from "../_interfaces/IResult";

export const ResultsClear = (rid: string) => {
    fetch(apiAddress + "/results/clear/" + rid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    s_results.value = [];
                }
            }
        )
}

export const ResultsAdd = (result: IResult) => {
    fetch(apiAddress + "/results/", createOptions('POST', result))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    let results = s_results.value;
                    results.unshift(result)
                    s_results.value = results;
                }
            }
        )
}

